import ConsultaBase from "../shared/ConsultaBase";
import { optichiller1CompConsultaConfig } from "../config/optichiller1compConsulta";

const COptichiller1Comp = () => {
  return <ConsultaBase config={optichiller1CompConsultaConfig} />;
};

export default COptichiller1Comp;